import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './Intro.css';
import { Button, Grid } from '@mui/material';

const Intro = () => {
  const { t } = useTranslation();
  return (
    <Grid container className='intro' id='home' style={{ scrollMarginTop: 'clamp(96px, 10vw, 212px)' }}>
      <Grid item justifyContent={'center'} alignContent={'center'}>
        <h1 >{t(`intro.title`)}<span>{t(`intro.title2`)}</span></h1>
        <h2 >{t(`intro.description`)}</h2>
        <img src={Images.tiim.logo} alt='logo' />
        <Button className='button' variant="contained" onClick={() => window.location.href = "mailto:hello@tiimapp.com"}>
          {t(`intro.demo`)}
        </Button>
      </Grid>
    </Grid>
  )
}

export default Intro 